import { render, staticRenderFns } from "./DeliverySettings.vue?vue&type=template&id=80218fb2&scoped=true&"
import script from "./DeliverySettings.vue?vue&type=script&lang=js&"
export * from "./DeliverySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80218fb2",
  null
  
)

export default component.exports